if (!window._initBreezeCart) {
    window._initBreezeCart = true;

    const CART_ADD_ENDPOINT = '/cart/add.js';

    const originalFetch = window.fetch
    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);

        const requestUrl = typeof args[0] === 'string' ? args[0] : args[0]?.url;

        if (requestUrl && CART_ADD_ENDPOINT.includes(requestUrl)) {
            setTimeout(() => {
                const cartDrawer = document.querySelector('[data-id="cart-side-drawer"]');
                if (cartDrawer) {
                    cartDrawer.click();
                }
            }, 800);
        }
        return response;
    }
}